var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col gap-4" },
    [
      _vm.isReallocated
        ? _c("emd-alert", {
            staticClass: "eu-mt_5",
            attrs: {
              noClose: "",
              variant: "warning",
              title: _vm.$t("alert.title"),
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function () {
                    return [
                      _vm._v(" " + _vm._s(_vm.$t("alert.content")) + " "),
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v(" " + _vm._s(_vm.$t("alert.link")) + " "),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2862607993
            ),
          })
        : _vm._e(),
      _c(
        "jade-box",
        { attrs: { title: _vm.$t("servideOrder") } },
        [
          [
            _vm.loadingList
              ? _c(
                  "div",
                  {
                    staticClass: "eu-pa_6 eu-align_center",
                    attrs: { "data-testid": "show-loading" },
                  },
                  [_c("jade-spinner")],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "py-2" },
                  [
                    _c("Table", {
                      attrs: {
                        fields: _vm.fields,
                        items: [_vm.translatedPhysicalWorldOrder],
                      },
                    }),
                  ],
                  1
                ),
          ],
        ],
        2
      ),
      _c(
        "jade-box",
        { attrs: { title: _vm.$t("information"), hasPadding: "" } },
        [
          [
            _vm.loadingList
              ? _c(
                  "div",
                  {
                    staticClass: "eu-pa_6 eu-align_center",
                    attrs: { "data-testid": "show-loading" },
                  },
                  [_c("jade-spinner")],
                  1
                )
              : _c("form-shell", {
                  staticClass: "eu-no-border",
                  attrs: {
                    formsOnShell: _vm.formsOnShell,
                    onlyFields: "",
                    removePadding: "",
                  },
                }),
          ],
        ],
        2
      ),
      _c("history-details", {
        attrs: {
          historyFields: _vm.historyFields,
          loading: _vm.loadingList,
          title: "service-order-history",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }